import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../../interfaces/base";
import { IFetchDashboardActiveUsersState } from "../../../../interfaces/store/dashboard-interface";

const initialState: IFetchDashboardActiveUsersState = {
  traineesCount: null,
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
};

const _getTraineeCountsStart = (
  state: IFetchDashboardActiveUsersState,
  { payload }: PayloadAction<any>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getTraineeCountsSuccess = (
  state: IFetchDashboardActiveUsersState,
  { payload }: PayloadAction<any>
) => {
  state.traineesCount = payload.data;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getTraineeCountsFailed = (
  state: IFetchDashboardActiveUsersState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetDashboardActiveUsers = (state: IFetchDashboardActiveUsersState) => {
  return { ...initialState };
};

const DashboardActiveUsersSlice = createSlice({
  name: "dashboardActiveUsers",
  initialState,
  reducers: {
    getTraineeCountsStart: _getTraineeCountsStart,
    getTraineeCountsSuccess: _getTraineeCountsSuccess,
    getTraineeCountsFailed: _getTraineeCountsFailed,
    resetDashboardActiveUsers: _resetDashboardActiveUsers,
  },
});

export const {
  getTraineeCountsStart,
  getTraineeCountsSuccess,
  getTraineeCountsFailed,
  resetDashboardActiveUsers,
} = DashboardActiveUsersSlice.actions;
export default DashboardActiveUsersSlice.reducer;
